import { render, staticRenderFns } from "./Registro.vue?vue&type=template&id=3ee007a5&"
import script from "./Registro.vue?vue&type=script&lang=ts&"
export * from "./Registro.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Registro.vue"
export default component.exports